import { render, staticRenderFns } from "./StudentFileModal.vue?vue&type=template&id=513198c6&scoped=true"
import script from "./StudentFileModal.vue?vue&type=script&lang=js"
export * from "./StudentFileModal.vue?vue&type=script&lang=js"
import style0 from "./StudentFileModal.vue?vue&type=style&index=0&id=513198c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513198c6",
  null
  
)

export default component.exports